import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isOpen: false,
  messages: [],
  externalQuery: null,
};

const aiAssistantSlice = createSlice({
  name: 'aiAssistant',
  initialState,
  reducers: {
    setIsOpen: (state, action) => {
      state.isOpen = action.payload;
    },
    setMessages: (state, action) => {
      state.messages = action.payload;
    },
    addMessage: (state, action) => {
      const nextMessages = [...state.messages, action.payload];
      state.messages = nextMessages.slice(-40); // MAX_HISTORY
    },
    updateAssistantMessage: (state, action) => {
      const { id, text } = action.payload;
      const msgIndex = state.messages.findIndex((m) => m.id === id);
      if (msgIndex !== -1) {
        state.messages[msgIndex].text = text;
      }
    },
    clearMessages: (state, action) => {
      state.messages = action.payload; // initial messages
    },
    setExternalQuery: (state, action) => {
      state.externalQuery = action.payload;
    }
  },
});

export const { setIsOpen, setMessages, addMessage, updateAssistantMessage, clearMessages, setExternalQuery } = aiAssistantSlice.actions;
export default aiAssistantSlice.reducer;
